import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { DossieClient } from "@/client/modules/dossie/dossie-client";
import Loading from "@/client/modules/dossie/loading";
import { formatWeekdayLongBR } from "@/shared/datetime";

export const Route = createFileRoute("/app/dossie")({
  loader: ({ context }) => ensurePage(context.queryClient, apiQuery("dossie", "page", {})),
  head: () => pageHead("Dossiê do dia"),
  pendingComponent: Loading,
  component: DossiePage,
});

function DossiePage() {
  const { data } = useApiSuspenseQuery("dossie", "page", {});
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader
        title="Dossiê do dia"
        description={`${formatWeekdayLongBR(new Date())} — um resumo de cada paciente antes de ele chegar.`}
      />
      <DossieClient rows={data} />
    </div>
  );
}
